import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';


// 在这里执行全局的初始化操作  
function globalInit() {
    // TODO
    // location.href = 'http://localhost:8080/#/home/index'
    // location.href = 'https://www.networkvape.com/#/home/index'
}

// 调用全局初始化函数  
// globalInit();



import preventReClick from './utils/preventReClick' //防多次点击，重复提交
Vue.use(preventReClick)

router.beforeEach((to, from, next) => {
    // chrome
    document.body.scrollTop = 0
    // firefox
    document.documentElement.scrollTop = 0
    // safari
    window.pageYOffset = 0
    next()
})


import SelectSkuAddCar from "@/components/SelectSkuAddCar.vue"

Vue.component("SelectSkuAddCar", SelectSkuAddCar);

import ElementUI, {
    Notification
} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

import CPagination from "@/components/Pagination.vue"

Vue.component("CPagination", CPagination)

// 无缝轮播列表
import scroll from 'vue-seamless-scroll'

Vue.use(scroll);

import dataV from '@jiaminghi/data-view';

// 轮播图
import VueAwesomeSwiper from "vue-awesome-swiper"; // swiper
import "swiper/css/swiper.css";

// echarts图表
import * as echarts from 'echarts'

Vue.prototype.$echarts = echarts
import axios from 'axios'

Vue.prototype.$http = axios //全局注册，使用方法：this.$http
import {
    request
} from '@/utils/request'

Vue.prototype.$post = (url = "", data = {}) => {
    return request({
        method: "POST",
        url: url,
        data
    })
}
Vue.prototype.$get = (url = "", params = {}) => {
    return request({
        method: "GET",
        url: url,
        params
    })
}
Vue.prototype.$DEL = (url = "", params = {}) => {
    return request({
        method: "DELETE",
        url: url,
        params
    })
}
Vue.prototype.$PUT = (url = "", data = {}) => {
    return request({
        method: "PUT",
        url: url,
        data
    })
}

Vue.prototype.$customUpload = (file) => {
    var formData = new FormData();
    formData.append('file', file)
    return request({
        method: 'POST',
        url: '/system/oss/upload',
        data: formData,
        Headers: {
            'Content-type': 'multipart/form-data'
        }
    })
}


Vue.prototype.$getImageUrl = function (url) {
    const index = url.lastIndexOf(".");
    // 如果 . 的位置不在字符串末尾，且不在第一位，则返回后缀
    if (index !== -1 && index !== 0 && index !== url.length - 1) {
        var suffix = url.substr(index + 1);
        switch (suffix) {
            case 'excel':
            case 'xls':
            case 'xlsx':
                return require(`@/assets/images/source1/EXCEL.png`);
                break;
            case 'jpg':
                return require(`@/assets/images/source1/JPG.png`);
                break;
            case 'mp3':
                return require(`@/assets/images/source1/MP3.png`);
                break;
            case 'pdf':
                return require(`@/assets/images/source1/PDF.png`);
                break;
            case 'png':
                return require(`@/assets/images/source1/PNG.png`);
                break;
            case 'ppt':
            case 'pptx':
                return require(`@/assets/images/source1/PPT.png`);
                break;
            case 'rar':
                return require(`@/assets/images/source1/RAR.png`);
                break;
            case 'txt':
                return require(`@/assets/images/source1/TXT.png`);
                break;
            case 'word':
            case 'doc':
            case 'docx':
                return require(`@/assets/images/source1/WORD.png`);
                break;
            case 'zip':
                return require(`@/assets/images/source1/ZIP.png`);
                break;
            case 'mp4':
                return require(`@/assets/images/source1/MP4.png`);
                break;
            default:
                return require(`@/assets/images/source1/PNG.png`);
        }
    } else {
        return "";
    }
}


import moment from 'moment';

Vue.mixin({
    methods: {
        formatTime(shijiancuo = 0) {
            return moment(shijiancuo * 1000).utc().format('YYYY.MM.DD')
        },
        // 商品列表属性格式化
        goodListAttrFormat(list = []) {
            return list.map(item => {
                let firstFlavors = {};
                if (item.flavors && item.flavors[0]) firstFlavors = item.flavors[0]
                let firstNicotine = {};
                if (item.nicotines && item.nicotines[0]) firstNicotine = item.nicotines[0]
                return {
                    ...item,
                    loading: false,
                    firstFlavors,
                    firstFlavorsName: firstFlavors.name || "",
                    firstNicotine,
                    firstNicotineName: firstNicotine.content,
                }
            })
        },
        // 去商品详情
        toGoodDetail(info, num) {
            // 秒杀  1
            if (num == 1) {
                localStorage.setItem("GOOD_num", 1);
            } else {
                localStorage.setItem("GOOD_num", 0);
            }
            if (!info) return this.$msg("需要传商品信息", "e");
            console.warn(info, "info")
            // localStorage.setItem("GOOD_INFO", JSON.stringify(info));
            this.$router.push('/home/goodDetail?goodsId=' + info.goodsId);
        },
    }
})

Vue.prototype.eventBus = new Vue();

// 文字样式
import '@/assets/font/stylesheet.css'


Vue.config.productionTip = false; //阻止显示生产模式的消息
Vue.config.silent = false;
Vue.config.productionTip = false;

// 自定义组件
import GoodList from '@/components/GoodList/GoodList.vue'

Vue.component("GoodList", GoodList);

// 全局注册
Vue.use(dataV);
Vue.use(VueAwesomeSwiper);

// 自定义消息
Vue.prototype.$msg = function (msg, type = "success") {
    if (!msg) return;
    Notification({
        title: msg,
        type: type == "success" ? "success" : "error",
    })
};

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');